import { render, staticRenderFns } from "./FSDatepicker.vue?vue&type=template&id=4480a508&scoped=true&"
import script from "./FSDatepicker.vue?vue&type=script&lang=js&"
export * from "./FSDatepicker.vue?vue&type=script&lang=js&"
import style0 from "./FSDatepicker.vue?vue&type=style&index=0&id=4480a508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4480a508",
  null
  
)

export default component.exports